import { Box } from '@ff-it/ui';
import { AddButton } from 'components';
import { header, oddRow } from 'styles/style.css';
import { fmt } from 'utilities';
import { table } from '../NetLinker/style.css';
import { Row } from './Row';
import { actionColumn, amountColumn, centeredCell, iconColumn, numberCell, tableCell } from './style.css';
import type { ImportedBlocksLinkerProps, ImportedBlockGroup } from './types';
import { useImportedBlocksLinker } from './useImportedBlocksLinker';

export function ImportedBlocksLinker({ expense, linkerContext }: ImportedBlocksLinkerProps) {
  const { groups, totals, handleLinkAll } = useImportedBlocksLinker({
    expense,
    linkerContext,
  });

  if (groups.length === 0) {
    return null;
  }

  const validGroups = groups.filter((g: ImportedBlockGroup) => g.canAutoLink);
  const invalidGroups = groups.filter((g: ImportedBlockGroup) => !g.canAutoLink);

  return (
    <Box mb="3">
      <table className={table}>
        <colgroup>
          <col className={iconColumn} />
          <col />
          <col className={actionColumn} />
          <col className={amountColumn} />
          <col className={amountColumn} />
          <col className={actionColumn} />
        </colgroup>
        <thead>
          <tr className={header.default}>
            <td className={centeredCell}></td>
            <td className={tableCell}>Imported blocks</td>
            <td></td>
            <td className={numberCell}>Expense</td>
            <td className={numberCell}>Balance</td>
            <td className={centeredCell}></td>
          </tr>
        </thead>
        {validGroups.length > 0 && (
          <tbody>
            <tr className={header.dark}>
              <th className={centeredCell} />
              <th className={tableCell}>Auto-linkable</th>
              <th className={centeredCell} />
              <th className={numberCell}>{fmt(totals.valid.expenseAmount)}</th>
              <th className={numberCell}>{fmt(totals.valid.linkableAmount)}</th>
              <th className={centeredCell}>
                <AddButton icon="circle-plus" onClick={handleLinkAll} />
              </th>
            </tr>
            {validGroups.map((group: ImportedBlockGroup, idx: number) => (
              <tr key={group.blockCode} className={idx % 2 === 0 ? undefined : oddRow}>
                <Row group={group} linkerContext={linkerContext} />
              </tr>
            ))}
          </tbody>
        )}
        {invalidGroups.length > 0 && (
          <tbody>
            <tr className={header.dark}>
              <th className={centeredCell} />
              <th className={tableCell}>Manual review required</th>
              <th className={centeredCell} />
              <th className={numberCell}>{fmt(totals.invalid.expenseAmount)}</th>
              <th className={numberCell}>{fmt(totals.invalid.linkableAmount)}</th>
              <th className={centeredCell} />
            </tr>
            {invalidGroups.map((group: ImportedBlockGroup, idx: number) => (
              <tr key={group.blockCode} className={idx % 2 === 0 ? undefined : oddRow}>
                <Row group={group} linkerContext={linkerContext} />
              </tr>
            ))}
          </tbody>
        )}
      </table>
    </Box>
  );
}
